import { useSearchParams } from "../../hooks/useRouter";
import {
  Card,
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "@/ui-components/ui";
import {
  SignIn as ClerkSignIn,
  SignUp as ClerkSignUp,
} from "@clerk/clerk-react";

const CLERK_APPEARANCE_BASE = {
  rootBox: "shadow-none border-none bg-transparent w-full rounded-none",
  cardBox: "shadow-none border-none bg-transparent w-full rounded-none",
  formButtonPrimary: "auth-button",
  formFieldLabel:
    "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  formFieldInput:
    "flex h-10 w-full border bg-background text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm rounded-lg border-border px-3 sm:px-4 py-3 transition-all duration-200 ease-out hover:border-border focus:border-[#01B9D9] focus:ring-2 focus:ring-[#01B9D9]/20 my-2",
  card: "shadow-none border-none bg-transparent p-0 sm:p-2 w-full",
  footer: "hidden",
  formFieldAction:
    "text-sm text-[#01B9D9] hover:text-[#01B9D9] hover:underline",
};

const CLERK_APPEARANCE_SIGNIN = {
  elements: {
    ...CLERK_APPEARANCE_BASE,
    header: "hidden",
  },
};

const CLERK_APPEARANCE_SIGNUP = {
  elements: {
    ...CLERK_APPEARANCE_BASE,
    headerTitle: "text-2xl font-bold text-foreground text-center",
    headerSubtitle: "text-muted-foreground mt-2 text-center",
    logoBox: "hidden",
    logoImage: "hidden",
  },
};

export const RightPanel = () => {
  const searchParams = useSearchParams();
  const connectTool = searchParams.get("connect");
  const redirect = searchParams.get("redirect");
  const urlTab = searchParams.get("tab");
  const redirectTo = decodeURIComponent(redirect || "/");

  // Check for preferred auth method: URL param > localStorage > default to signup
  const storedMethod =
    typeof window !== "undefined"
      ? localStorage.getItem("auth_last_method")
      : null;
  const defaultTab = urlTab || storedMethod || "signup";

  // Store the user's choice when they switch tabs manually
  const handleTabChange = (value: string) => {
    if (value === "signin" || value === "signup") {
      localStorage.setItem("auth_last_method", value);
    }
  };

  return (
    <div className="flex-1 flex items-center justify-center p-4 sm:p-8">
      <div className="w-full max-w-md">
        {/* Mobile logo */}
        <div className="lg:hidden mb-6 text-center">
          <a href="/" className="inline-block">
            <img
              src="/specstorylogo.svg"
              alt="SpecStory"
              className="h-8 w-auto mx-auto"
            />
          </a>
        </div>

        {connectTool && (
          <Card className="mb-6 p-4 bg-[#01B9D9]/10 border-[#01B9D9]/20">
            <p className="text-sm text-foreground">
              Sign in to connect{" "}
              <span className="font-semibold">{connectTool}</span> to your
              SpecStory account
            </p>
          </Card>
        )}

        <Card className="p-4 sm:p-8 bg-card border-border">
          <Tabs
            defaultValue={defaultTab}
            onValueChange={handleTabChange}
            className="w-full"
          >
            <TabsList className="grid w-full grid-cols-2 mb-8">
              <TabsTrigger value="signin">Sign In</TabsTrigger>
              <TabsTrigger value="signup">Sign Up</TabsTrigger>
            </TabsList>

            <TabsContent value="signin" className="space-y-6">
              <div className="text-center mb-6">
                <h2 className="text-2xl font-bold text-foreground">
                  Welcome back
                </h2>
                <p className="text-muted-foreground mt-2">
                  Sign in to your SpecStory account
                </p>
              </div>

              <div className="space-y-4">
                <ClerkSignIn
                  appearance={CLERK_APPEARANCE_SIGNIN}
                  fallbackRedirectUrl={redirectTo}
                />
              </div>
            </TabsContent>

            <TabsContent value="signup" className="space-y-6">
              <div className="space-y-4">
                <ClerkSignUp
                  appearance={CLERK_APPEARANCE_SIGNUP}
                  fallbackRedirectUrl={redirectTo}
                />
              </div>
            </TabsContent>
          </Tabs>
        </Card>
      </div>
    </div>
  );
};
